var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.319 27.6379C21.6748 27.6379 27.6379 21.6748 27.6379 14.319C27.6379 6.9631 21.6748 1 14.319 1C6.9631 1 1 6.9631 1 14.319C1 21.6748 6.9631 27.6379 14.319 27.6379Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3189 27.6379C17.9968 27.6379 20.9784 21.6748 20.9784 14.319C20.9784 6.9631 17.9968 1 14.3189 1C10.641 1 7.65942 6.9631 7.65942 14.319C7.65942 21.6748 10.641 27.6379 14.3189 27.6379Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.319 1V27.6379",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.319 20.9786C21.6748 20.9786 27.6379 17.9971 27.6379 14.3192C27.6379 10.6412 21.6748 7.65967 14.319 7.65967C6.9631 7.65967 1 10.6412 1 14.3192C1 17.9971 6.9631 20.9786 14.319 20.9786Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6379 14.3188H1",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetIcon);
export default __webpack_public_path__ + "static/media/INTERNETIcon.a2413c6c2ec64068fb8a2a58e3ec3263.svg";
export { ForwardRef as ReactComponent };